'use client';

import { useUnit } from 'effector-react';
import classNames from 'classnames';
import { Icon, IconsMap } from '@nx-frontend/shared/ui/icon';
import { $transcriptPanel, toggleTranscriptPanelVisibilityEvent } from '@nx-frontend/shared/store/transcript-panel';

interface TranscriptPanelHideBtnProps {
  style?: React.CSSProperties;
  additionClass?: string;
}

export function TranscriptPanelHideBtn(props: TranscriptPanelHideBtnProps) {
  const { style = {}, additionClass } = props;
  const [transcriptPanel] = useUnit([$transcriptPanel]);
  const [toggleTranscriptPanelVisibility] = useUnit([toggleTranscriptPanelVisibilityEvent]);
  return (
    <button
      onClick={toggleTranscriptPanelVisibility}
      className={classNames(
        'transcript-panel-hide-btn absolute top-0 flex items-center justify-center w-[24px] h-[24px] border border-neutral-200 rounded-[4px] bg-white',
        'group hover:bg-cyan-900',
        transcriptPanel.visible ? '' : 'rotate-180',
        additionClass
      )}
      style={style}
    >
      <Icon icon={IconsMap.ARROW_RIGHT_RIGHT} className="w-[16px] h-[16px] text-neutral-500 group-hover:text-white" />
    </button>
  );
}
